import { useRef, useEffect, useState } from 'react';
import { TopContentSection } from '../../ToolsPageLayout/ToolsPageLayout.styles';
import { useAppDispatch, useAppSelector } from '../../../base';
import { toolsActions, toolsSelectors, userSelectors } from '../../../actions';
import EmptyChat from '../EmptyChat';
import ChatHistoryViewer from '../ChatHistoryViewer';
import ChatInput from './ChatInput';
import ResultsDisplay from './ResultsDisplay';
import {
    ChatContainer,
    MainChatWrapper,
    ContentDisplayWrapper,
} from './ActiveChat.styles';
import { TempMessageAndChatIds } from '../../../common';
import PargodaLoading from '../../PargodaLoading';

const ActiveChat = () => {
    const activeChatId = useAppSelector(toolsSelectors.getActiveChatId);
    const activeCompany = useAppSelector(toolsSelectors.getActiveCompany);
    const dispatch = useAppDispatch();
    const activeChatHistoryLoading = useAppSelector(
        toolsSelectors.getActiveChatHistoryLoading
    );
    const activeChatMessages = useAppSelector(
        toolsSelectors.getActiveChatMessages
    );
    const userData = useAppSelector(userSelectors.getMyUser);
    const activeChatQuestions = useAppSelector(
        toolsSelectors.getActiveChatQuestions
    );
    const activeChatQuestionsLoading = useAppSelector(
        toolsSelectors.getActiveChatQuestionsLoading
    );
    const results = useAppSelector(
        toolsSelectors.getActiveChatGeneratedContent
    );
    const [showResults, setShowResults] = useState(false);

    const topContentRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (topContentRef.current) {
            topContentRef.current.scrollTop =
                topContentRef.current.scrollHeight;
        }
    }, [activeChatMessages]);

    useEffect(() => {
        if (
            activeChatId &&
            activeChatId !== TempMessageAndChatIds.TEMP_CHAT_ID &&
            activeCompany &&
            activeChatMessages.length === 0
        ) {
            dispatch(
                toolsActions.fetchActiveChatHistory({
                    chatId: activeChatId,
                    companyId: activeCompany?.value || '',
                })
            );
        }
    }, [activeChatId, activeCompany, dispatch]);

    useEffect(() => {
        setShowResults(results && results.length > 0);
    }, [results]);

    const renderTopComponent = () => {
        if (activeChatQuestionsLoading || activeChatHistoryLoading) {
            return <PargodaLoading />;
        } else {
            if (activeChatId) {
                return <ChatHistoryViewer />;
            } else {
                return (
                    <EmptyChat
                        userName={userData?.firstName || 'Friend'}
                        questionText={activeChatQuestions[0]?.title}
                    />
                );
            }
        }
    };

    return (
        <ChatContainer>
            <MainChatWrapper hasResults={showResults}>
                <TopContentSection ref={topContentRef}>
                    {renderTopComponent()}
                </TopContentSection>
                <ChatInput />
            </MainChatWrapper>
            <ContentDisplayWrapper show={showResults}>
                <ResultsDisplay show={showResults} setShow={setShowResults} />
            </ContentDisplayWrapper>
        </ChatContainer>
    );
};

export default ActiveChat;
